import { render, staticRenderFns } from "./BaseApp.vue?vue&type=template&id=2a193bb6&"
import script from "./BaseApp.vue?vue&type=script&lang=js&"
export * from "./BaseApp.vue?vue&type=script&lang=js&"
import style0 from "./BaseApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports